"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseElement = void 0;
/**
 * The base class for all BPMN elements, including processes, participants, etc.
 */
class BaseElement {
}
exports.BaseElement = BaseElement;
//# sourceMappingURL=BaseElement.js.map